import { z } from 'zod';
import { PaymentEventTypeSchema } from './enums.schema.js';
export const PaymentEventResponseSchema = z.object({
    id: z.string().uuid(),
    invoiceId: z.string().uuid(),
    eventType: PaymentEventTypeSchema,
    amountCents: z.number().int(),
    externalRef: z.string().nullable(),
    recordedAt: z.string().datetime(),
    recordedByUserId: z.string().uuid().nullable(),
    createdAt: z.string().datetime(),
});
//# sourceMappingURL=payment-event.schema.js.map